<template>
<div>
    <h5 class="pb-1 mb-4 f-140" :class="report_theme_color">{{$t(`전문가 실사 종합의견`)}}</h5>

    <div v-if="is_conclusion_by_company_loaded==true" class="">
            <!-- <h4 class="mb-45 tail-line"> {{ is_recommendations_by_company_loaded==true?'전문가 의견 및 개선과제':'전문가 의견' }}</h4> -->     
        <b-card class="bg-reportbg border-0 mb-3 f-100">
            <div v-if="$i18n.locale=='en'" v-html="conclusion_by_company.conclusion_e" class="text-justify"></div>
            <div v-else v-html="conclusion_by_company.conclusion" class="p-3 text-justify font-scale-3 "></div>
        </b-card>
    </div>

</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: "TotalConclusion",
    props: {
        mode: {
            type: String
        },
    },
    data() {
        return {}
    },
    computed:{
        ...mapState('reviews', ['conclusion_by_company', 'is_conclusion_by_company_loaded', 'recommendations_by_company', 'is_recommendations_by_company_loaded']),
        report_theme_color(){            
            if(this.mode=='audit'){
                return 'border-bottom border-color-red border-width-2 red8'
            }else return 'border-bottom border-color-report1 border-width-2 c-report1'
        }
    },
}
</script>

<style>

</style>